module.exports = __webpack_public_path__ + "img/icon-email.24a68df2.svg";